import {call, put} from 'redux-saga/effects';
import {takeEvery} from 'redux-saga';
import ProfileApi from '../../profile/api';
import * as Actions from './actions.forgotPw';
import * as Types from './actions.forgotPw.types';

export default function* forgotPasswordFlow() {
  yield [
    takeEvery(Types.FORGOT_PW_REQUEST, forgotPasswordRequest),
    takeEvery(Types.FORGOT_PW_RESET, forgotPasswordConsume)
  ];
}

function* forgotPasswordRequest(action) {
  const {email} = action;
  try {
    const response = yield call(ProfileApi.forgotPasswordRequest, email);
    yield put(Actions.requestForgotPwSuccess(response));
  } catch (error) {
    yield put(Actions.requestForgotPwFailure(error));
  }
}

function* forgotPasswordConsume(action) {
  const {token, newPassword} = action;
  try {
    const response = yield call(ProfileApi.forgotPasswordConsume, token, newPassword);
    yield put(Actions.resetForgotPwSuccess(response));
  } catch (error) {
    yield put(Actions.resetForgotPwFailure(error));
  }
}



// WEBPACK FOOTER //
// ./shared/auth/redux/sagas.forgotPw.js